import React from 'react';
import { Button, Progress, Space, Typography } from 'antd';
import { Notice } from '../common/Notice';
import { LeftOutlined, RightOutlined, CheckCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface QuestionGroupNavProps {
  currentGroupIndex: number;
  totalGroups: number;
  isFirstGroup: boolean;
  isLastGroup: boolean;
  canAdvance: boolean;
  loading?: boolean;
  onNext: () => void;
  onPrev: () => void;
  onSubmit: () => void;
}

export const QuestionGroupNav: React.FC<QuestionGroupNavProps> = ({
  currentGroupIndex,
  totalGroups,
  isFirstGroup,
  isLastGroup,
  canAdvance,
  loading = false,
  onNext,
  onPrev,
  onSubmit,
}) => {
  const displayIndex = currentGroupIndex + 1;
  const progressPercent = totalGroups > 0 ? Math.round((displayIndex / totalGroups) * 100) : 0;

  return (
    <div
      data-testid="question-group-nav"
      style={{ display: 'flex', flexDirection: 'column', gap: 16 }}
    >
      {/* Progress indicator */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <Text type="secondary" data-testid="group-progress-label">
          Grupo {displayIndex} de {totalGroups}
        </Text>
        <Progress
          percent={progressPercent}
          showInfo={false}
          style={{ flex: 1 }}
          strokeColor="#1677ff"
        />
      </div>

      {/* Navigation buttons */}
      <Space style={{ justifyContent: 'space-between', width: '100%' }}>
        {!isFirstGroup ? (
          <Button
            icon={<LeftOutlined />}
            onClick={onPrev}
            disabled={loading}
            data-testid="btn-prev"
          >
            Voltar
          </Button>
        ) : (
          <span /> // placeholder to keep flex layout
        )}

        {isLastGroup ? (
          <Button
            type="primary"
            icon={<CheckCircleOutlined />}
            onClick={onSubmit}
            disabled={!canAdvance || loading}
            loading={loading}
            data-testid="btn-submit"
          >
            Enviar Respostas
          </Button>
        ) : (
          <Button
            type="primary"
            icon={<RightOutlined />}
            iconPosition="end"
            onClick={onNext}
            disabled={!canAdvance || loading}
            loading={loading}
            data-testid="btn-next"
          >
            Avançar
          </Button>
        )}
      </Space>
    </div>
  );
};

// ─── State messages ──────────────────────────────────────────────────────────

export const GroupProfileIncompleteMessage: React.FC = () => (
  <Notice
    type="warning"
    showIcon
    message="Perfil incompleto"
    description="Seu perfil não possui estado cadastrado. Atualize seu perfil para responder esta pesquisa."
    data-testid="profile-incomplete-message"
  />
);

export const GroupNoGroupsMessage: React.FC = () => (
  <Notice
    type="info"
    showIcon
    message="Nenhum bloco disponível"
    description="Esta pesquisa não possui grupos de perguntas disponíveis para o seu perfil."
    data-testid="no-groups-message"
  />
);
